import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("hs_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Si è verificato un errore. Riprova.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const fileUrl = (p) => `${API}/files/${p}`;
export const clipUrl = (n) => `${API}/clipart/${n}.svg`;
export const eur = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n || 0);
export const fmtDate = (s) => (s ? new Date(s).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }) : "");

export async function fetchBlobUrl(config) {
  const r = await api.request({ responseType: "blob", ...config });
  return URL.createObjectURL(r.data);
}

export async function downloadFile(config, filename) {
  const u = await fetchBlobUrl(config);
  const a = document.createElement("a");
  a.href = u;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(u), 4000);
}

export const STATUS_LABELS = {
  in_attesa_pagamento: "In attesa di pagamento",
  ricevuto: "Ricevuto (pagamento differito)",
  pagato: "Pagato",
  in_produzione: "In produzione",
  spedito: "Spedito",
  completato: "Completato",
  annullato: "Annullato",
};
